import clsx from 'clsx';

import {BoxProps} from '@mui/material';

import {palette} from 'styles/mui/scss';

import {Box} from 'components/basic-components';

import {CustomIcon} from '../CustomIcon/CustomIcon';
import styles from './responseMessage.module.scss';

interface ResponseMessageProps {
  children: React.ReactNode;
  variant: 'error' | 'success' | 'info' | 'default';
  filled?: boolean;
  defaultPadding?: boolean;
  responsiveIcon?: boolean;
  sx?: BoxProps['sx'];
}

const ResponseMessage: React.FC<ResponseMessageProps> = ({
  children,
  variant,
  filled = false,
  defaultPadding = true,
  responsiveIcon = false,
  sx,
}) => {
  return (
    <Box
      className={clsx({
        [styles.responseMessage]: true,
        [styles.defaultPadding]: defaultPadding,
        [styles.success]: variant === 'success',
        [styles.error]: variant === 'error',
        [styles.info]: variant === 'info',
        [styles.backgroundInfo]: filled && variant === 'info',
        [styles.backgroundError]: filled && variant === 'error',
        [styles.backgroundSuccess]: filled && variant === 'success',
      })}
      sx={sx}
    >
      <CustomIcon
        name={variant === 'success' ? 'checkmark' : variant === 'error' ? 'close' : 'info'}
        style={{color: filled ? palette.colorWhite : palette.colorBlack}}
        className={clsx({[styles.icon]: !responsiveIcon, [styles.responsiveIcon]: responsiveIcon})}
      />

      <Box sx={{color: filled ? palette.colorWhite : palette.colorBlack}} className={styles.text}>
        {children}
      </Box>
    </Box>
  );
};

export default ResponseMessage;
